module.exports = __webpack_public_path__ + "static/media/down.6b447235.svg";